import Vue from 'vue'

const state = {
  baseUri: '/botw/visit/check/',
  mainUri: '/botw/visit/main/',
  fileUri: '/botw/file/'
}
const getters = {
}
const actions = {
  mainSearch: function (_context, [paramData, callback]) { // 메인 : 금월/금년 방문점검 현황 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.mainUri + 'search',
      params: paramData
    }
    console.log('visitMain-mainSearch : ', axiosOption.params)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  codes: function (_context, [paramData, callback]) { // 점검 현황 - 코드 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes',
      params: paramData
    }
    console.log('test visitCheck-codes : ', axiosOption.params, callback)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [paramData, callback]) { // 점검 현황 - 리스트 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: paramData
    }
    console.log('visitCheck-search : ', axiosOption.params)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [paramData, callback]) { // 상세조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail',
      params: paramData
    }
    console.log('visitCheck-detail', axiosOption.params)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  infoUpdate: function (_context, [paramData, callback]) { // 점검 현황 - 정보 수정
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'infoUpdate',
      data: paramData
    }
    console.log('visitCheck-infoUpdate', axiosOption.data)
    Vue.axios(axiosOption).then(callback)
  },
  checkUpdate: function (_context, [paramData, callback]) { // 점검 현황 - 저장
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'checkUpdate',
      data: paramData
    }
    console.log('visitCheck-checkUpdate', axiosOption.data)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  checkComplete: function (_context, [paramData, callback]) { // 점검 현황 - 완료
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'checkComplete',
      data: paramData
    }
    console.log('visitCheck-checkComplete: ', axiosOption.data)
    Vue.axios(axiosOption).then(callback)
  },
  completeCancel: function (_context, [paramData, callback]) { // 점검 현황 - 완료 취소
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'completeCancel',
      data: paramData
    }
    console.log('visitCheck-completeCancel: ', axiosOption.data)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  checkUserList: function (_context, [paramData, callback]) { // 점검 현황 - 방문점검자 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'userList',
      params: paramData
    }
    console.log('visitCheck-checkUserList : ', axiosOption.params)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileDown: function (_context, [fileObj, callback]) {
    const axiosOption = {
      method: 'GET',
      url: fileObj.fileUrl,
      responseType: 'blob'
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileMemoUpdate: function (_context, [paramData, callback]) { // 파일 메모 수정
    const axiosOption = {
      method: 'POST',
      url: _context.state.fileUri + 'memoUpdate',
      data: paramData
    }
    console.log('visitCheck-fileMemoUpdate: ', axiosOption.data)
    Vue.axios(axiosOption)
      .then(callback)
      .catch((err) => {
        console.log(err)
      })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
